import { useContext } from "react";
import { PackageBold } from "../bold/package-bold";
import { PackageDuotone } from "../duotone/package-duotone";
import { PackageFill } from "../fill/package-fill";
import { PackageLight } from "../light/package-light";
import { PackageRegular } from "../regular/package-regular";
import { PackageThin } from "../thin/package-thin";
import { IconContext } from "./IconContextProvider";
const weightMap = {
  regular: PackageRegular,
  bold: PackageBold,
  duotone: PackageDuotone,
  fill: PackageFill,
  light: PackageLight,
  thin: PackageThin
};
const Package = (props) => {
  const {
    color: contextColor,
    size: contextSize,
    weight: contextWeight,
    style: contextStyle
  } = useContext(IconContext);
  const {
    color = contextColor ?? "black",
    size = contextSize ?? 24,
    weight = contextWeight ?? "regular",
    style = contextStyle ?? {},
    ...otherProps
  } = props;
  const Component = weightMap[weight];
  return <Component
    color={color}
    size={size}
    weight={weight}
    style={style}
    {...otherProps}
  />;
};
export {
  Package
};
//# sourceMappingURL=Package.js.map
